import { modelVersions } from '../services/constants';
import {
    fetchSettingsSubstrate,
    fetchSettingsPotplants,
} from '../services/parameters';
import readSettings from './readSettings';
import {
    startInitializeStore,
    initializeError,
    initializeStore,
} from './actions';

/**
 *
 * @ param {import('./initialState').TStore} store
 * @param {Object} store
 * @param {string} store.modelVersion
 * @param {function} dispatch
 * @param {string} nextKey
 */
export const changeKey = (store, dispatch, nextKey) => {
    // const prevKey = store.key;
    const modelVersion = store.modelVersion;

    let fetchConfig;
    dispatch(startInitializeStore({ key: nextKey, modelVersion }));

    if (modelVersion === modelVersions.substraat) {
        fetchConfig = fetchSettingsSubstrate(nextKey);
    } else {
        fetchConfig = fetchSettingsPotplants(nextKey);
    }
    return fetchConfig
        .then((rawSettings) => {
            const convertedSettings = readSettings(rawSettings, modelVersion);
            // console.log("fetchSettings raw data:", rawSettings);
            // console.log("convertedSettings:", convertedSettings);
            dispatch(initializeStore(convertedSettings));
            return true;
        })
        .catch((err) => {
            dispatch(initializeError(err));
            return false;
        });
};
